export const CODE_NUMBER_LENGTH = 6;
